module.exports = __webpack_public_path__ + "static/img/cqxc3.356b802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/cqxc3.png
// module id = B7BI
// module chunks = 0